if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      
      // If there's a URL, fetch recommendations (original behavior)
      if (this.dataset.url) {
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const recommendationsHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-recommendations]')?.innerHTML;
            if (!recommendationsHTML) return;
            this.classList.remove('hidden');
            var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
            if(cartDrawerItemsFull) {
              cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
            }
            recommendations.innerHTML = recommendationsHTML;
            this.initSlider();

            // initiate quick cart after fetch
            // to activate trigger button events
            setTimeout(() => {
              if (document.querySelector("quick-cart-drawer")) {
                document.querySelector("quick-cart-drawer").init();
              } else {
                // if quick-cart-drawer does not exists, remove trigger buttons
                this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                  el?.remove();
                })
              }
            }, 500);
          });
      } else {
        // If no URL, products are already in DOM - just initialize slider
        const hasProducts = recommendations.querySelector('.swiper-slide');
        if (hasProducts) {
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          this.initSlider();
          
          // initiate quick cart
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);
        }
      }
    }

    initSlider() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl || swiperEl.swiper) return; // Already initialized

      // Swiper bundle may not be ready yet (e.g. after an AJAX re-render).
      // Retry once it is available instead of failing silently.
      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', () => this.initSlider(), { once: true });
        return;
      }

      const previousButton = this.querySelector(
        '.product-recommendations__button--prev'
      );
      const nextButton = this.querySelector(
        '.product-recommendations__button--next'
      );
      const sliderOptions = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        // The carousel is often initialized while hidden (cart drawer) or
        // before the layout settles. These let Swiper recompute its size and
        // navigation state when the slider becomes visible or its content changes.
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
      };

      if (previousButton && nextButton) {
        sliderOptions.navigation = {
          prevEl: previousButton,
          nextEl: nextButton,
        };
      }

      this.slider = new Swiper(swiperEl, sliderOptions);
      this.observeSlideResize(swiperEl);
    }

    // Slide widths come from a stylesheet that can apply *after* Swiper has
    // initialized (the markup is injected via innerHTML when the cart drawer
    // re-renders). If Swiper measures zero-width slides it locks the navigation
    // arrows for good. Watch the wrapper and recompute once the slides settle.
    observeSlideResize(swiperEl) {
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper || typeof ResizeObserver === 'undefined') return;

      this.resizeObserver = new ResizeObserver(() => {
        if (this.slider) this.slider.update();
      });
      this.resizeObserver.observe(wrapper);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    // Recompute sizes and navigation state. Call this when the carousel
    // becomes visible (e.g. when the cart drawer opens).
    updateSlider() {
      if (this.slider) {
        this.slider.update();
      } else {
        this.initSlider();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
